module.exports = __webpack_public_path__ + "static/media/minimo.0853dabe.svg";